import { GetOtherDeviceNameWithTranslation } from './Functions/GetNameWithTranslation';
import { DinDeviceI } from './redux/types/app';

export const dinDevices: DinDeviceI[] = [
    {
        type: 'MCB10',
        name: GetOtherDeviceNameWithTranslation('','modular_circuit_breaker_1ph'),
        refImg: 'MCB_1POL.png',
        icon: 'breaker_din_1',
        modules: 1,
        priceAmpers: [
            {
                ampers: 16,
                price: 2.3
            },
            {
                ampers: 20,
                price: 3
            },
            {
                ampers: 32,
                price: 3.7
            },
            {
                ampers: 40,
                price: 5
            },
            {
                ampers: 63,
                price: 6.2
            }
        ],
        category: 'MCB'
    },
    {
        type: 'MCB10',
        name: GetOtherDeviceNameWithTranslation('','modular_circuit_breaker_3ph'),
        refImg: 'MCB_3POL.png',
        icon: 'breaker_din_3',
        modules: 3,
        priceAmpers: [
            {
                ampers: 16,
                price: 10.2
            },
            {
                ampers: 20,
                price: 10.2
            },
            {
                ampers: 25,
                price: 11.4
            },
            {
                ampers: 32,
                price: 13.2
            },
            {
                ampers: 40,
                price: 18
            },
            {
                ampers: 50,
                price: 19.4
            },
            {
                ampers: 63,
                price: 21.4
            }
        ],
        category: 'MCB'
    },
    {
        type: 'AFI2',
        name: GetOtherDeviceNameWithTranslation('','residual_current_circuit_breaker_1ph'),
        refImg: 'RCCB_AFI2.png',
        icon: 'breaker_din_2',
        modules: 2,
        priceAmpers: [
            {
                ampers: 25,
                miliampers: 0.03,
                price: 20.9
            },
            {
                ampers: 25,
                miliampers: 0.3,
                price: 20.9
            },
            {
                ampers: 25,
                miliampers: 0.5,
                price: 20.9
            },
            {
                ampers: 40,
                miliampers: 0.03,
                price: 24.8
            },
            {
                ampers: 40,
                miliampers: 0.3,
                price: 24.8
            },
            {
                ampers: 63,
                miliampers: 0.03,
                price: 29.8
            },
            {
                ampers: 63,
                miliampers: 0.3,
                price: 29.8
            }
        ],
        category: 'RCCB'
    },
    {
        type: 'AFI4',
        name: GetOtherDeviceNameWithTranslation('','residual_current_circuit_breaker_3ph'),
        refImg: 'RCCB_AFI4.png',
        icon: 'breaker_din_4',
        modules: 4,
        priceAmpers: [
            {
                ampers: 25,
                miliampers: 0.03,
                price: 22.4
            },
            {
                ampers: 25,
                miliampers: 0.3,
                price: 22.4
            },
            {
                ampers: 25,
                miliampers: 0.5,
                price: 22.4
            },
            {
                ampers: 40,
                miliampers: 0.03,
                price: 24.8
            },
            {
                ampers: 40,
                miliampers: 0.3,
                price: 24.8
            },
            {
                ampers: 40,
                miliampers: 0.5,
                price: 24.8
            },
            {
                ampers: 63,
                miliampers: 0.03,
                price: 29.8
            },
            {
                ampers: 63,
                miliampers: 0.3,
                price: 29.8
            },
            {
                ampers: 63,
                miliampers: 0.5,
                price: 29.8
            }
        ],
        category: 'RCCB'
    },
    {
        type: 'VS120-10',
        name: GetOtherDeviceNameWithTranslation('','contactor_1'),
        refImg: 'VS-120-10.png',
        icon: 'breaker_din_1',
        modules: 1,
        price: 19.6,
        category: 'contactor'
    },
    {
        type: 'VS220-20',
        name: GetOtherDeviceNameWithTranslation('','contactor_2'),
        refImg: 'VSM-220-20.png',
        icon: 'breaker_din_1',
        modules: 1,
        price: 23.1,
        category: 'contactor'
    },
    {
        type: 'VSM220-20',
        name: GetOtherDeviceNameWithTranslation('','contactor_manual_2'),
        refImg: 'VSM-220-20.png',
        icon: 'breaker_din_1',
        modules: 1,
        price: 25.9,
        category: 'contactor'
    },
    {
        type: 'VS425-40',
        name: GetOtherDeviceNameWithTranslation('','contactor_4_25'),
        refImg: 'VS425-40.png',
        icon: 'breaker_din_2',
        modules: 2,
        price: 25.4,
        category: 'contactor'
    },
    {
        type: 'VSM425-40',
        name: GetOtherDeviceNameWithTranslation('','contactor_manual_4_25'),
        refImg: 'VSM-425-40.png',
        icon: 'breaker_din_2',
        modules: 2,
        price: 27,
        category: 'contactor'
    },
    {
        type: 'VS440-40',
        name: GetOtherDeviceNameWithTranslation('','contactor_4_40'),
        refImg: 'VS440-40.png',
        icon: 'breaker_din_4',
        modules: 4,
        price: 55,
        category: 'contactor'
    },
    {
        type: 'VS463-40',
        name: GetOtherDeviceNameWithTranslation('','contactor_4_63'),
        refImg: 'VS463-40.png',
        icon: 'breaker_din_4',
        modules: 4,
        price: 63,
        category: 'contactor'
    },
    {
        type: 'Generic bell',
        name: GetOtherDeviceNameWithTranslation('','generic_bell'),
        refImg: 'generic_bell.png',
        icon: 'breaker_din_1',
        modules: 1,
        price: 30,
        category: 'other'
    }
];

export const MCBDevices: DinDeviceI[] = dinDevices.filter((device) => device.category === 'MCB');
export const RCCBDevices: DinDeviceI[] = dinDevices.filter((device) => device.category === 'RCCB');
export const ContactorDevices: DinDeviceI[] = dinDevices.filter((device) => device.category === 'contactor');
export const OtherDevices: DinDeviceI[] = dinDevices.filter((device) => device.category === 'other');
